import { render, staticRenderFns } from "./LayoutFolderBrowserModal.vue?vue&type=template&id=47969308&scoped=true"
import script from "./LayoutFolderBrowserModal.vue?vue&type=script&lang=js"
export * from "./LayoutFolderBrowserModal.vue?vue&type=script&lang=js"
import style0 from "./LayoutFolderBrowserModal.vue?vue&type=style&index=0&id=47969308&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47969308",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47969308')) {
      api.createRecord('47969308', component.options)
    } else {
      api.reload('47969308', component.options)
    }
    module.hot.accept("./LayoutFolderBrowserModal.vue?vue&type=template&id=47969308&scoped=true", function () {
      api.rerender('47969308', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modals/LayoutFolderBrowserModal.vue"
export default component.exports